export const stepsVisaoGeral = [
  {
    target: '.stepSaldo',
    content: `Neste gráfico você consegue visualizar o saldo total de todas as contas cadastradas para sua empresa na data de hoje.
             <br/><br/>
             Ao passar o mouse em cima deste ícone, serão exibidas todas as contas com seus respectivos saldos.`,
    disableBeacon: true,
    placement: 'bottom-start',
  },
  {
    target: '.stepContasPagar',
    content: `Aqui você consegue visualizar o somatório dos valores de contas a pagar em aberto com vencimento na data de hoje.
             <br/><br/>
             Ao clicar em "Hoje", será exibida uma lista de opções para você mudar a exibição.`,
    placement: 'bottom-start',
  },
  {
    target: '.stepContasReceber',
    content: `Aqui você consegue visualizar o somatório dos valores de contas a receber em aberto com vencimento na data de hoje.
             <br/><br/>
             Ao clicar em "Hoje", será exibida uma lista de opções para você mudar a exibição.`,
    placement: 'bottom-start',
  },
  {
    target: '.stepInadimplencia',
    content: `Aqui você consegue visualizar o somatório dos valores de títulos inadimplentes,
             ou seja, contas a receber em aberto com data de vencimento anterior à data atual.`,
    placement: 'bottom-start',
  },
  {
    target: '.stepFluxoDeCaixa',
    content: `Neste gráfico você pode visualizar a Previsão de fluxo de caixa para o dia atual e os próximos seis dias.
             <br/><br/>
             Este gráfico mostra as despesas e receitas que têm previsão de baixa em cada dia da semana, considerando a data de vencimento.
             <br/>
             Também é possível visualizar o saldo total que terá na empresa após as baixas previstas.`,
    placement: 'right-start',
  },
  {
    target: '.stepGraficoInadimplencia',
    content: `Neste gráfico você pode visualizar o somatório dos valores de títulos inadimplentes considerando a quantidade de dias em atraso, 
             ou seja, contas a receber em aberto, com data de vencimento anterior à data atual, agrupados por dias de atraso.`,
    placement: 'left-start',
  },
  {
    target: '.stepReceitasXDespesas',
    content: `Neste gráfico você pode visualizar o somatório dos valores baixados das contas a receber e das contas a pagar em cada mês.
             <br/>
             O sistema exibirá os últimos 12 meses, incluindo o mês atual.`,
    placement: 'top-end',
  },
  {
    target: '.stepGraficoVendas',
    content: `Neste gráfico você pode visualizar o somatório dos valores das vendas aprovadas que ocorreram na última semana, mês e ano, considerando a data e mês atual.
             <br/>
             Ao lado do valor, o sistema exibe a evolução de vendas em relação ao mês anterior.`,
    placement: 'left-start',
  },
];